import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { AllowanceIncidenceFragment } from 'generated/resources/graphql'

import { formatCounterAmount } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

interface IncidenceProps {
  allowanceIncidence: AllowanceIncidenceFragment
  isHourlyFixedBalance: boolean
}

const Incidence = ({ allowanceIncidence, isHourlyFixedBalance }: IncidenceProps) => {
  const days = allowanceIncidence.daysInCents / 100
  const sign = days > 0 ? '+' : '-'

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{i18n.t('time_off.allowance_tooltip.holiday')}</Text.Normal>
        <Text.Normal>{`${sign} ${formatCounterAmount(
          Math.abs(days),
          isHourlyFixedBalance,
        )}`}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">{allowanceIncidence.description}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Incidence
